import TablePage from '@/found/components/table_page';
import request from '@/found/utils/request';
import { ProcessLog } from '@/found/modules';
import detailsInfo from '../form/details/index';

export default {
  extends: TablePage,
  components: {
    detailsInfo,
    ProcessLog,
  },
  name: 'cash_distribution',
  data() {
    return {

    };
  },
  created() {
    this.getConfigList('page_list', 'CRM20260309000000002');
  },

  methods: {
    modalClick({
      val,
      row,
    }) {
      if (val.code === 'view') {
        this.formName = 'detailsInfo';
        this.modalConfig.title = '查看';
        this.formConfig = {
          code: val.code,
          row,
        };
        this.openFull();
      } else if (val.code === 'process_log') {
        this.formConfig = {
          ...this.formConfig,
          code: val.code,
          row: { processNo: row.processNo },
        };

        this.modalConfig.title = '流程日志';

        this.formName = 'ProcessLog';
        this.openDrawer();
      }
    },
  },
};
